module.exports = __webpack_public_path__ + "2178caa9e62939a488573a4e983b1a86.MP3";